import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Produto } from 'src/app/core/models/produto.model';
import { InputNumberInputEvent } from 'primeng/inputnumber';
import { NovoPedidoProdutoRequest } from 'src/app/core/models/request/novo-pedido.request.model';

@Component({
  selector: 'app-pedido-laboratorio',
  templateUrl: './pedido-laboratorio.component.html',
  styleUrls: ['./pedido-laboratorio.component.scss']
})
export class PedidoLaboratorioComponent implements OnInit {
  @Input() servicosAdicionados: Produto[] = [];
  @Input() dadosForm: any;
  @Input() codLoja: number | undefined;
  @Input() codCliente: number | undefined;

  maxDate: Date = new Date();
  duplicarSelecionado: Produto;
  produtoDuplicado: Array<Produto> = [];


  tiposMontagem: any[] = [
    {
      id: 1,
      nome: 'Aro fechado'
    },
    {
      id: 2,
      nome: 'Meio Aro (Fio de Nylon)'
    },
    {
      id: 3,
      nome: 'Três peças (Balgriff)'
    },
    {
      id: 4,
      nome: 'Esportiva'
    }
  ];

  
  maxlength: number = 5;

  ngOnInit(): void { }

  DnpLongeEsquerdoChange($event: boolean) {
    this.calcularReceita();
  }

  DnpLongeDireitoChange($event: boolean) {
    this.calcularReceita();
  }

  armacaoChange($event: InputNumberInputEvent) {
    this.calcularReceita();
  }

  calcularReceita() {
    let olhoEsquerdo = this.dadosForm.olhoEsquerdo;
    let olhoDireito = this.dadosForm.olhoDireito;  
    
    setTimeout(() => {
      let esquerdoDNPLonge = olhoEsquerdo?.olhoLongeDNP ?? '';
      let direitoDNPLonge = olhoDireito?.olhoLongeDNP ?? '';

      let menorDNP = esquerdoDNPLonge > direitoDNPLonge ?
        direitoDNPLonge : esquerdoDNPLonge;

      let diametroApurado =
        (this.dadosForm.armacao?.armacaoPonte ?? 0) +
        (this.dadosForm.armacao?.armacaoAro ?? 0) +
        (this.dadosForm.armacao?.armacaoDiagMaior ?? 0) -
        (2 * (Number(menorDNP.toString().replace(',', '.')))) + 2;

      this.dadosForm.armacao.armacaoDiamApurado = diametroApurado;

      let esquerdoDNPL = Number(esquerdoDNPLonge.toString().replace(',', '.'));
      let direitoDNPL = Number(direitoDNPLonge.toString().replace(',', '.'));
      
      if ( esquerdoDNPL > 0 && direitoDNPL > 0) {
        let distanciaPupilar = esquerdoDNPL + direitoDNPL;
        // this.dadosForm.armacao.armacaoDistPupilar = Math.round(distanciaPupilar)
        this.dadosForm.armacao.armacaoDistPupilar = this.formatarInputBlur(distanciaPupilar);
      }

    }, 500);

  }

  formatarInputBlur(input: any) {

    const formatoNovo = input.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2});

    return formatoNovo

  }
  
  formatarInput(input: any, campo?: string): void {
    const inputNumericValue = input.value.replace(/[^\d.-]/g, '');
    const isNegative = inputNumericValue.startsWith('-');
    const isPositive = !isNegative;
    
    if (isPositive || isNegative) {
      let number = parseFloat(inputNumericValue) / 100;

      let formattedValue = number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      if (formattedValue === 'NaN') {
          formattedValue = '-';
      }
      input.value = formattedValue;

    } else {
        input.value = '';
    }

  }

  parseNumber(value: string) {
    return Number((value ?? '0').replace('.', '').replace(',', '.'));
  }

  changeProduto(produto: Produto, tipo: string) {
    let index = this.servicosAdicionados.findIndex(x => x.tipo_prod === tipo);
    if (index >= 0) {
      this.servicosAdicionados.splice(index, 1);
    }

    if (produto && typeof produto != "string") {
      const servico = JSON.parse(JSON.stringify(produto));
      servico.tipo_prod = tipo;
      servico.quantidadeAdd = tipo === 'D'
        ? (this.dadosForm.olhoDireito?.olhoQuantidade ?? 1)
        : (this.dadosForm.olhoEsquerdo?.olhoQuantidade ?? 1);
      this.servicosAdicionados.push(servico);
      this.duplicarProduto(servico, produto);
    }
  }

  changeQuantidade(quantidade: number, tipo: string) {
    const idx = this.servicosAdicionados.findIndex(x => x.tipo_prod === tipo);
    if (idx >= 0) {
      this.servicosAdicionados[idx].quantidadeAdd = quantidade;
    }
  }

  existeTipo(tipo: "E" | "D") {
    return !!this.servicosAdicionados.find(p => p.tipo_prod == tipo);
  }

  duplicarProduto(servico: Produto, produto: Produto) {
    if (!servico || !["E", "D"].includes(servico.tipo_prod) || this.dadosForm.opcaoOlhoSelecionado != 'ambos') {
      return;
    }

    const clone_produto = JSON.parse(JSON.stringify(servico));
    clone_produto.tipo_prod = produto.tipo_prod == "E" ? "D" : "E";
    if (!this.existeTipo(clone_produto.tipo_prod)) {
      this.servicosAdicionados.push(clone_produto);
      if (clone_produto.tipo_prod == "D") {
        this.dadosForm.olhoDireito = { ...this.dadosForm.olhoDireito, olhoLente: produto, olhoQuantidade: servico.quantidadeAdd };
      }
      else {
        this.dadosForm.olhoEsquerdo = { ...this.dadosForm.olhoEsquerdo, olhoLente: produto, olhoQuantidade: servico.quantidadeAdd };
      }
    }
  }

  removerProdutosTipos(tipos: string[] = ['D', 'E']) {
    let eof = true;
    do {
      eof = true;
      for (let i = 0; i < this.servicosAdicionados.length; i++) {
        const service = this.servicosAdicionados[i];
        if (tipos.includes(service.tipo_prod)) {
          this.servicosAdicionados.splice(i, 1);
          eof = false;
          break;
        }
      }
    } while(!eof);
  }

  verificarProduto(tipo?: string) {
    if (tipo == 'E') {
      this.removerProdutosTipos(['D']);
      this.dadosForm.olhoDireito = {};
    }
    else if (tipo == 'D') {
      this.removerProdutosTipos(['E']);
      this.dadosForm.olhoEsquerdo = {};
    }
    else {
      this.removerProdutosTipos(['D', 'E']);
      this.dadosForm.olhoDireito = {};
      this.dadosForm.olhoEsquerdo = {};
    }

    this.duplicarSelecionado = undefined as any;
    this.produtoDuplicado = this.servicosAdicionados;
  }
}
